import React from 'react'
import { Header } from '../components/Header'
import Navbar from '../components/Navbar'
import Store from '../components/Store'

function Shop() {
  return (
    <div className='page'>
        <Navbar/>
        <Header heading="Shop"/>
        <Store/>
    </div>
  )
}

export default Shop